import axios from 'axios'
import {toast} from 'react-toastify'
import _ from 'lodash'
import { setAttendanceTracking } from '../features/authentication/attendance'

const instance = axios.create(
    {
        baseURL: process.env.REACT_APP_BASE_URL + '/api',
        headers: {'Content-Type': 'application/json'}
    }
);

instance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    let response = error.response;
    let message = _.get(response, 'data.message', 'Internal Server Error');
    toast.error(message);
    if (response.status === 401) {
        setAttendanceTracking((endpoint, body) => instance.post(endpoint, body))
            .finally(() => {
                client.logout();
                window.location.reload();
            });
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});

export async function client(endpoint, body) {
    const config = {
        url: endpoint,
        method: 'post',
        data: body
    };
    try {
        const response = await instance(config);
        return response.data
    } catch (err) {
        return Promise.reject(_.get(err.response, 'data', 'Internal Server Error'))
    }
}

client.setAuthorizationToken = function (token) {
    if (token) {
        instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete instance.defaults.headers.common['Authorization']
    }
};

client.logout = function () {
    localStorage.removeItem('auth');
    client.setAuthorizationToken()
};

client.post = function (endpoint, body) {
    return client(endpoint, body)
};